module.exports = __webpack_public_path__ + "img/check-circle.e6a895da.svg";